import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeSubscriptions:null,
};

export const subscriptionSlice = createSlice({
    initialState,
    name: 'subscriptionSlice',
    reducers: {
        setActiveSubscriptions: (state, { payload }) => {
            state.activeSubscriptions = payload
        },
    },
});

export default subscriptionSlice.reducer;

export const { setActiveSubscriptions } = subscriptionSlice.actions;
export const selectSubscription = (state) => state.subscription.activeSubscriptions;